<template>
  <b-list-group-item>
    <b-row no-gutters>
      <b-col cols="3">
        <img
          class="img128 shadow"
          :alt="item.Description"
          :src="`${base_url}/../../../ui/document_preview/${item.id}`"
        />
      </b-col>
      <b-col cols="7">
        <strong>{{ item.Description }}</strong> ({{ item.Size | formatBytes }})
        <div
          class="text-muted"
          v-if="item.related_description || item.other_related_objects.length"
        >
          Associato a: <br />
          <ul>
            <li v-if="item_url">
              <a :href="item_url">
                <b-icon icon="link" />
                {{ item.related_description }}</a
              >
            </li>
            <li class="ex-small" v-else>
              <b-icon icon="info-square" />
              {{ item.related_description }}
            </li>
            <li
              v-for="lnk in item.other_related_objects"
              :key="lnk.url"
              class="ex-small"
            >
              <a :href="'#' + lnk.url">
                <b-icon :icon="lnk.icon" />
                {{ lnk.label }}</a
              >
            </li>
          </ul>
        </div>
      </b-col>
      <b-col cols="2">
        <a
          :href="`${base_url}/../../../ui/download_document/${item.id}`"
          target="_blank"
        >
          <b-icon icon="download" />
          Scarica</a
        >
      </b-col>
    </b-row>
    <!--    <pre>{{ item }}</pre>-->
  </b-list-group-item>
</template>

<script>
import _ from "lodash";

export default {
  name: "DocumentItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
    term: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      model_name_mapping: {
        "pb_net.pb_serials": "#/resource/<%= related_object_id %>",
        "magonet.magonetcustomers": "#/customer/<%= related_object_id %>",
      },
    };
  },
  filters: {},
  methods: {
    yes_no(value) {
      return value ? "Si" : "No";
    },
  },
  computed: {
    base_url: () => window.base_url,
    item_url: function () {
      if (!this.model_name_mapping[this.item.related_contenttype]) {
        return;
      }
      return _.template(this.model_name_mapping[this.item.related_contenttype])(
        this.item
      );
    },
  },
};
</script>

<style scoped>
.ex-small {
  font-size: 70%;
}
</style>
